import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var TaskListSvg = function TaskListSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.472 10.823h-4.396V9.342h4.395zM17.472 16.329h-4.396v-1.482h4.395zM11.48 7.971l-3.072 4.394-2.42-2.414L7.02 8.898l1.186 1.183 2.073-2.964zM8.408 17.97l3.073-4.394-1.2-.854-2.074 2.964-1.186-1.183-1.033 1.053z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.978 2H3v20h18V7.064zM4.469 20.519V3.48h10.9l4.162 4.196V20.52z",
    clipRule: "evenodd"
  }));
};
export var TaskList = function TaskList(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: TaskListSvg
  }));
};